export const getSeparatedString = (arr?: unknown[], separator = ', ') => {
    return (arr || []).filter(Boolean).join(separator);
};
